import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "19",
  viewBox: "0 0 18 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.00195 2.07424e-05L15.0019 0C16.6588 -2.44377e-06 18.002 1.34314 18.002 3V13.0358C18.002 14.6926 16.6588 16.0357 15.002 16.0358L12.3757 16.0358L9.63566 18.3058C9.26392 18.6138 8.72523 18.6123 8.35528 18.3021L5.65157 16.0358H3.00195C1.3451 16.0358 0.00195312 14.6926 0.00195312 13.0358V3.00002C0.00195312 1.34317 1.3451 2.31862e-05 3.00195 2.07424e-05ZM12.4569 6.95711C12.8474 6.56658 12.8474 5.93342 12.4569 5.54289C12.0663 5.15237 11.4332 5.15237 11.0427 5.54289L8.24976 8.33579L7.45686 7.54289C7.06634 7.15237 6.43317 7.15237 6.04265 7.54289C5.65212 7.93342 5.65212 8.56658 6.04265 8.95711L7.54265 10.4571C7.73019 10.6446 7.98454 10.75 8.24976 10.75C8.51498 10.75 8.76933 10.6446 8.95687 10.4571L12.4569 6.95711Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }